module.exports = __webpack_public_path__ + "static/media/Fundraiser_purple.a1c73109.png";